import { api, TokenProvider } from '@src/main/modules/common/common/infrastructure/http/axios';
import { User } from '@src/main/modules/common/user/domain/User';
import { UserRepository } from '@src/main/modules/common/user/domain/UserRepository';
import {
  mapFromResponseToDomain,
  UserResponse,
} from '@src/main/modules/common/user/infrastructure/UserResponse';

export const createUserHttpRepository = (tokenProvider: TokenProvider): UserRepository =>
  new UserHttpRepository(tokenProvider);

class UserHttpRepository implements UserRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  async findUser(): Promise<User> {
    const token = await this.tokenProvider.getToken();
    const response = await api.get<UserResponse>('/user/me', token);
    return mapFromResponseToDomain(response);
  }

  async findAllUsers(): Promise<User[]> {
    const token = await this.tokenProvider.getToken();
    const response = await api.get<UserResponse[]>('/users', token);
    return response.map(mapFromResponseToDomain);
  }

  async saveUser(user: User): Promise<void> {
    const token = await this.tokenProvider.getToken();
    await api.put('/user/me/info', token, {
      recentlyOpened: user.recentlyOpened,
      favorites: user.favorites,
    });
  }

  async addAdminRole(userId: string, userRoles: string[]): Promise<void> {
    const token = await this.tokenProvider.getToken();
    await api.put(`/user/${userId}`, token, {
      roles: userRoles,
    });
  }
}
